module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "brand-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.brands[0].hero_image_url
    }
  })]), _vm._v(" "), (_vm.sneakers != null) ? _c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_vm._l((_vm.sneakers), function(sneaker) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (sneaker.brand) + "/" + (sneaker.slug))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": sneaker.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sneaker.model_name))]), _vm._v(" "), _c('div', {
      staticClass: "grid-x card-info"
    }, [_c('div', {
      staticClass: "small-5 small-offset-1"
    }, [_c('p', [_vm._v(_vm._s(sneaker.release_date_pretty))])]), _vm._v(" "), _c('div', {
      staticClass: "small-5 small-offset-1"
    }, [(sneaker.original_price != 'TBA') ? _c('p', [_vm._v("€" + _vm._s(sneaker.original_price))]) : _c('p', [_vm._v(_vm._s(sneaker.original_price))])])])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.loadMoreSneakers()
      }
    }
  }, [_vm._v("Load more sneakers")])])], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-267ada12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Brand.vue
// module id = 69
// module chunks = 0